import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./styles/globals.scss";
import App from "./pages/App";
import "./i18n";
import appConfig from "./app.config.json";
import { addStyle, checkNavigationType } from "./utilities/Utils";
import axios from "axios";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://5d673a179b710e9cfd46cab9e9cdc533@o4511771206090752.ingest.us.sentry.io/4511771212185600",
    dataCollection: {
      // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
      // userInfo: false,
      // httpBodies: []
    },
  });
}

function renderApp(config) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <App config={config} />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}

let config;

if (config && checkNavigationType() === 1) {
  addStyle(`
      :root {
          --color-theme: ${config.theme.color}
      }`);
}

if (
  window.location.origin.includes("localhost") ||
  window.location.origin.includes("lpclub") ||
  process.env.NODE_ENV === 'development'
) {
  config = appConfig;

  addStyle(`
      :root {
          --color-theme: ${config.theme.color}
      }`);

  document.title = config.title;

  renderApp(config);
} else {
  let data = {
    method: "get",
    url: `${window.location.origin}/portal-config/langham-tenant.json`,
  };

  axios(data)
    .then((response) => {
      console.log(response);
      config = response.data;

      addStyle(`
      :root {
          --color-theme: ${config.theme.color}
      }`);

      document.title = config.title;

      renderApp(config);
    })
    .catch((error) => {
      console.log(error);
    });
}
